// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".event-review__trigger_cbb576b8{max-height:11rem;min-height:11rem;border:.084rem solid #dce1e5;border-radius:.333em}.event-review__trigger-wrapper_fc55ce34{min-width:9.3rem;max-height:9.3rem}.event-review__trigger-text_da474e16{white-space:pre-wrap;word-break:break-all}", ""]);
// Exports
export var eventReviewTrigger = "event-review__trigger_cbb576b8";
export var eventReviewTriggerWrapper = "event-review__trigger-wrapper_fc55ce34";
export var eventReviewTriggerText = "event-review__trigger-text_da474e16";
export default ___CSS_LOADER_EXPORT___;
